export default {"src":"/_next/static/media/ic-clock-white.982dba48.svg","height":14,"width":13};